import type { ThemeClasses } from "../types";
import { TrackingLinkFilters } from "./TrackingLinkFilters";
import { TrackingLinkViewToggle } from "./TrackingLinkViewToggle";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";
import { useTranslation } from "react-i18next";

interface TrackingLinkHeaderProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  accessType: string;
  status: string;
  searchQuery: string;
  selectedView: "grid" | "list";
  onAccessTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onStatusChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onViewChange: (view: "grid" | "list") => void;
  onAddNew: () => void;
}

export function TrackingLinkHeader({
  themeClasses,
  isDarkMode,
  accessType,
  status,
  searchQuery,
  selectedView,
  onAccessTypeChange,
  onStatusChange,
  onSearchChange,
  onViewChange,
  onAddNew,
}: TrackingLinkHeaderProps) {
  const { t: tCommon } = useTranslation("common");
  const disableCRUD = useDisableCRUD();
  return (
    <div className={`${themeClasses.bg} border-b ${themeClasses.border} px-4 py-3 sm:px-6 sm:py-4`}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mb-3">
        <div className="min-w-0">
          <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
            Gestión de Links de Seguimiento
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            Administra todos los links de seguimiento
          </p>
        </div>
        <button
          onClick={onAddNew}
          disabled={disableCRUD}
          title={disableCRUD ? tCommon("common.selectCompanyFirst") : undefined}
          className={`px-3 sm:px-4 py-2 rounded-lg font-medium flex items-center justify-center space-x-2 transition-colors whitespace-nowrap text-sm sm:text-base self-start sm:self-auto flex-shrink-0 ${
            disableCRUD
              ? "bg-primary-500/50 cursor-not-allowed text-gray-800"
              : "bg-primary-500 hover:bg-primary-400 text-gray-900"
          }`}
        >
          <i className="ri-add-line"></i>
          <span className="hidden sm:inline">Nuevo Link de Seguimiento</span>
          <span className="sm:hidden">Nuevo</span>
        </button>
      </div>

      <div className="flex items-center gap-2 min-w-0">
        <TrackingLinkFilters
          accessType={accessType}
          status={status}
          searchQuery={searchQuery}
          isDarkMode={isDarkMode}
          themeClasses={themeClasses}
          onAccessTypeChange={onAccessTypeChange}
          onStatusChange={onStatusChange}
          onSearchChange={onSearchChange}
        />

        <TrackingLinkViewToggle
          selectedView={selectedView}
          themeClasses={themeClasses}
          onViewChange={onViewChange}
        />
      </div>
    </div>
  );
}
